import { render, staticRenderFns } from "./PlayerSelectDialog.vue?vue&type=template&id=88b3e706&scoped=true&"
import script from "./PlayerSelectDialog.vue?vue&type=script&lang=js&"
export * from "./PlayerSelectDialog.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSelectDialog.vue?vue&type=style&index=0&id=88b3e706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b3e706",
  null
  
)

export default component.exports